import { buildTrainingLocation } from '@/pages/centrumSzkolen/Szkolenia/common/buildTrainingLocation'

const toDateKey = value => {
	const date = `${value || ''}`.substring(0, 10)
	return /^\d{4}-\d{2}-\d{2}$/.test(date) ? date : ''
}

const htmlToPlainText = value => `${value || ''}`
	.replace(/<br\s*\/?>/gi, '\n')
	.replace(/<\/(p|div|li|h[1-6])>/gi, '\n')
	.replace(/<[^>]+>/g, '')
	.replace(/&nbsp;/gi, ' ')
	.replace(/&amp;/gi, '&')
	.replace(/&lt;/gi, '<')
	.replace(/&gt;/gi, '>')
	.replace(/&quot;/gi, '"')
	.replace(/&#39;/gi, "'")
	.replace(/[ \t]+\n/g, '\n')
	.replace(/\n{3,}/g, '\n\n')
	.trim()

const formatLessonHours = value => {
	if (value === '' || value == null) return ''
	const number = Number(value)
	if (!Number.isFinite(number)) return ''
	const rounded = Math.round(number * 100) / 100
	return `${rounded}h lekcyjne`
}

const formatStepLocation = step => {
	const built = buildTrainingLocation({
		miasto: step?.miasto,
		ulica: step?.ulica || step?.adres,
		kod_pocztowy: step?.kod_pocztowy,
		location: step?.location,
	})
	return built && built !== '—' ? built : ''
}

const resolveProjectDateRange = steps => {
	const dates = steps.flatMap(step => {
		const start = toDateKey(step?.data_rozpoczecia)
		const end = toDateKey(step?.data_zakonczenia) || start
		return [start, end].filter(Boolean)
	}).sort()

	if (!dates.length) {
		return { start: '', end: '' }
	}

	return {
		start: dates[0],
		end: dates[dates.length - 1],
	}
}

const buildProjectNote = (project, steps) => {
	const projectName = `${project?.nazwa || ''}`.trim()
	const notes = htmlToPlainText(project?.opis) || htmlToPlainText(project?.uwagi)
	const projectId = `${project?._id || project?.id || ''}`.trim()
	const origin = typeof window !== 'undefined' ? window.location.origin : ''
	const link = projectId && origin
		? `${origin}/centrumSzkolen/moje-projekty/details/${projectId}`
		: ''

	const header = [
		`Projekt: ${projectName}`,
		'',
		`Notatki projektu: ${notes}`,
		'',
		'Link do projektu:',
		link,
	]

	const etapBlocks = steps.map((step, index) => {
		const pozycje = Array.isArray(step?.pozycje) ? step.pozycje : []
		const lines = [
			`Etap ${index + 1}`,
			`Placówka: ${`${step?.placowkaName || ''}`.trim()}`,
			`Lokalizacja: ${formatStepLocation(step)}`,
			`Data: ${toDateKey(step?.data_rozpoczecia)}`,
		]

		pozycje.forEach((pozycja, pozycjaIndex) => {
			const title = `${pozycja?.value || ''}`.trim()
			const startMatch = `${pozycja?.start_time || ''}`.trim().match(/^(\d{1,2}):(\d{2})/)
			const startTime = startMatch ? `${startMatch[1].padStart(2, '0')}:${startMatch[2]}` : ''
			const endMatch = `${pozycja?.end_time || ''}`.trim().match(/^(\d{1,2}):(\d{2})/)
			const endTime = endMatch ? `${endMatch[1].padStart(2, '0')}:${endMatch[2]}` : ''
			const hoursLabel = formatLessonHours(pozycja?.ilosc_godzin)
			const details = [
				title,
				startTime ? `start ${startTime}` : '',
				endTime ? `zakończenie ${endTime}` : '',
				hoursLabel,
			].filter(Boolean).join(' - ')
			lines.push(`Pozycja ${pozycjaIndex + 1}: ${details}`)
		})

		return lines.join('\n')
	})

	return [
		...header,
		'',
		etapBlocks.join('\n\n'),
	].join('\n').trim()
}

export const buildMyProjectCalendarPayload = project => {
	const steps = Array.isArray(project?.steps) ? project.steps : []
	const { start, end } = resolveProjectDateRange(steps)
	const description = buildProjectNote(project, steps)
	const projectName = `${project?.nazwa || ''}`.trim()

	return {
		_id: project?._id || project?.id || '',
		nazwa: projectName,
		allDay: true,
		data_rozpoczecia: start,
		data_zakonczenia: end || start,
		remarks: description,
		uwagi: description,
	}
}

export const formatLessonHoursLabel = formatLessonHours
